
require('normalize.css/normalize.css');
require('./styles/index.scss');

import Mouse from "./utils/mouse";
import Easing from "./utils/easing";
import Simplex from "./utils/simplex";


const canvas = document.querySelector('.main-canvas');

canvas.width = window.innerWidth * window.devicePixelRatio;
canvas.height = window.innerHeight * window.devicePixelRatio;
const ctx = canvas.getContext("2d");

let time = 0;
let simplex = new Simplex();

class Line {
	constructor() {

		this.alpha = 0.2;
		this.fract = 200;
		this.x = 0;
		this.y = 0;
	}

	draw(time, param1, param2) {

		ctx.save();
		ctx.translate(this.x, this.y);
		ctx.beginPath();
		ctx.globalAlpha = this.alpha;
		ctx.strokeStyle = '#ffffff';
		ctx.strokeWidth = 0.1;

		for (let i = 0; i < this.fract; i++) {


			const progress = i / (this.fract - 1);
			const n = simplex.noise4D(progress, time * 0.4, param1, param2);
			// const scale = Math.sin(time) * 300;
			const scale = 500;
			ctx.lineTo(progress * canvas.width, (n * scale));

		}

		ctx.stroke();
		ctx.restore();

	}
}

const global_random = Math.random() * 1000;

let mouseY = Mouse.cursor[1];
let mouseX = Mouse.cursor[0];

let dampX = mouseX;
let dampY = mouseY;

let space = 4;
const clip_radius = Math.min(canvas.width, canvas.height) * 0.4;

const line = new Line();

// à chaque image : 60fps
const update = () => {
	requestAnimationFrame(update);

	ctx.clearRect(0, 0, canvas.width, canvas.height);

	ctx.save();
	ctx.beginPath();
	ctx.arc(canvas.width / 2, canvas.height / 2, clip_radius, 0, Math.PI * 2, true);
	ctx.clip();

	mouseY = Mouse.cursor[1];
	mouseX = Mouse.cursor[0];

	const diffX = mouseX - dampX;
	const diffY = mouseY - dampY;

	dampX += diffX * 0.2;
	dampY += diffY * 0.2;

	line.y = 0;

	for (let i = 0; i < canvas.height / space; i++) {
		line.y += space;
		line.draw(global_random + (i * 0.02), time * 0.3, dampY + dampX * 0.5);
	}

	time += 0.01;
	
	ctx.restore();

};


window.addEventListener('click', () => {
});

requestAnimationFrame(update);